import getOr from "lodash/fp/getOr";
import { GLOBAL_CONSTANTS } from "../global/constants";
import { getCookie } from "./browser";
import { getCookieUtmParams } from "./script";
import { ROOT_GLOBAL } from "../global/root";
import xss from "xss";
import { LocalStorage } from "../models/LocalStorage";

const queryString = require('query-string');

export const removeURLParameter = (url, parameter) => {
  //prefer to use l.search if you have a location/link object
  const urlparts = url.split('?');
  if (urlparts.length >= 2) {

    const prefix = encodeURIComponent(parameter) + '=';
    const pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (let i = pars.length; i-- > 0;) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

export const changeQueryString = (key, value, url) => {
  if (!url) url = window.location.href;
  if (url.indexOf("http") === -1) {
    url = window.location.origin + url;
  }
  if ('URL' in window) {
    const result = new URL(url);
    if (typeof value !== 'undefined' && value !== null) {
      result.searchParams.set(key, value);
    } else {
      result.searchParams.delete(key);
    }
    return result.href;
  } else {
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
      hash;

    if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null) {
        return url.replace(re, '$1' + key + "=" + value + '$2$3');
      }
      else {
        hash = url.split('#');
        url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
        if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
          url += '#' + hash[1];
        }
        return url;
      }
    }
    else {
      if (typeof value !== 'undefined' && value !== null) {
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        hash = url.split('#');
        url = hash[0] + separator + key + '=' + value;
        if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
          url += '#' + hash[1];
        }
        return url;
      }
      else {
        return url;
      }
    }
  }
}

export const genHashUrl = (hash = "", url = window.location) => {
  let result = url.origin;
  if (url.pathname !== "/") {
    result += url.pathname;
  }
  if (url.search) {
    result += url.search;
  }
  return result + hash;
}

export const getShortLinkCode = (url = window.location.href) => {
  try {
    const parseUrl = new URL(url);
    return parseUrl.pathname.replace(/^\/s\/p\//, "").replace(/^\/s\//, "").replace("/", "");
  } catch (_) {
    return;
  }
}

export const isShortLinkProduct = (url = window.location.href) => {
  try {
    const parseUrl = new URL(url);
    return parseUrl.pathname.indexOf("/s/p/") === 0;
  } catch (_) {
    return false;
  }
}

export const mobileLink = (isProduct = false) => {
  let result = window.location.href.replace(window.location.origin, "https://dutycast.app.link").replace(window.location.pathname, "");
  // let uidEncode = genUidTime(getCookie(GLOBAL_CONSTANTS.UID));
  // result = changeQueryString(GLOBAL_CONSTANTS.UID, uidEncode, result);
  result = changeQueryString(GLOBAL_CONSTANTS.MOBILE_SHORT_LINK_PARAM, getShortLinkCode(), result);
  if (isProduct) {
    result = changeQueryString(GLOBAL_CONSTANTS.MOBILE_IS_PRODUCT_SHORT_LINK_PARAM, 1, result);
  }
  const url = new URL(result);
  const params = { ...(getCookieUtmParams() || {}), ...(getParamUrl(undefined, url.search) || {}) };
  return queryString.stringifyUrl({
    url: url.origin + url.pathname,
    query: params,
    fragmentIdentifier: url.hash.replace("#", ""),
  })
}


export function historyPushState(newurl, isReplace = false) {
  if (window.location.pathname + window.location.search !== newurl) {
    if (window.history.pushState) {
      if (isReplace && window.history.replaceState) {
        window.history.replaceState({ path: newurl }, '', newurl);
      } else {
        window.history.pushState({ path: newurl }, '', newurl);
      }
    } else {
      window.location.href = newurl;
    }
  }
}

export function replaceUrl(url) {
  if (getCookie(GLOBAL_CONSTANTS.COOKIE.PLATFORM) === "android" && window.history.pushState) {
    historyPushState(url, true);
    window.location.reload();
    return;
  }
  window.location.replace(url);
}

export function replaceScript(text = "") {
  if (Array.isArray(text)) {
    for (let index = 0; index < text.length; index++) {
      const element = text[index];
      text[index] = replaceScript(element);
    }
    return text;
  }
  if (!text || typeof text !== "string") return "";
  return xss(text, { stripIgnoreTag: true });
}

export function getParamUrl(name, source = window.location.search) {
  const data = queryString.parse(source);
  for (const [key, value] of Object.entries(data)) {
    data[key] = replaceScript(value);
  }
  return name ? getOr(undefined, name)(data) : data;
}

export function solveUrlParams(params, getRaw = false) {
  if (params) {
    Object.keys(params).forEach(key => {
      if (params[key] === "" || params[key] === undefined || params[key] === null) delete params[key];
    })
  }
  let result = "";
  result = getRaw ? queryString.stringify(params) : "?" + queryString.stringify(params);
  if (result === "?") {
    result = "";
  }
  return result;
}

export function genEndPointGetParam(endPoint = "", param = null) {
  const result = (!!endPoint && typeof (endPoint) === "string" ? endPoint : "/");
  return result + solveUrlParams(param);
}

export function changeUtmParams(url, utmQuery) {
  let result = url;
  const cookieUtm = getCookie(GLOBAL_CONSTANTS.COOKIE.UTM);
  if (cookieUtm) {
    return url;
  } else {
    let searchParams = getParamUrl(undefined, utmQuery);
    if (searchParams && Object.keys(searchParams).length > 0) {
      Object.keys(searchParams).forEach(key => {
        result = changeQueryString(key, searchParams[key], result)
      });
    }
  }
  return result;
}

export const genUrlParams = (params) => {
  return queryString.stringify(params);
}

export function getRedirectURL(redirectUrl, installUrl, shoppingUrl) {
  let installed = LocalStorage.hasExtension(), shopping = $("body").attr("dce_cart");
  let result = "";

  if (installUrl && installUrl !== "undefined") {
    if (installed) {
      if (shoppingUrl && shoppingUrl !== "false") {
        if (typeof (shoppingUrl) === "string" && shoppingUrl !== "true" && shopping + "" !== "true" && shopping + "" !== "undefined") {
          result = shoppingUrl;
        } else {
          result = shopping ? ROOT_GLOBAL.CHECKOUT + "/" + shopping : redirectUrl;
        }
      } else {
        result = redirectUrl;
      }
    } else {
      result = installUrl;
    }
  } else {
    result = redirectUrl;
  }

  return result;
}

export const urlFullFill = (url) => {
  if (!url) {
    return "";
  }

  if (url.indexOf("http") === 0) {
    return url;
  }

  if (url.indexOf("//") === 0) {
    return `https:${url}`;
  }

  if (url.indexOf("/") === 0) {
    return `${window.location.origin}${url}`;
  }

  return `https://${url}`;
}